export default __webpack_public_path__ + "static/media/iqbal-2nIBkSxJQ0E-unsplash2.84b2fbf2.jpg";